module.exports = __webpack_public_path__ + "static/img/第六届企业论坛.8290987e.jpg";